import { useEffect, useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { usePermissoes, limparCachePermissoes } from '../hooks/usePermissoes'
import api from '../services/api'

export default function Layout({ children }) {
  const navigate = useNavigate()
  const location = useLocation()
  const usuario = JSON.parse(localStorage.getItem('pg_usuario') || '{}')
  const { pode } = usePermissoes()
  const [badges, setBadges] = useState({ aprovacoes: 0, cidadaos: 0 })
  const senhaProvisoria = localStorage.getItem('pg_trocar_senha') === 'true'

  useEffect(() => {
    let ativo = true
    async function carregarBadges() {
      const novosBadges = { aprovacoes: 0, cidadaos: 0 }
      try {
        const [t, a] = await Promise.all([
          api.get('/aprovacoes/triagem').then(r=>r.data.length).catch(()=>0),
          api.get('/aprovacoes/pendentes').then(r=>r.data.length).catch(()=>0),
        ])
        novosBadges.aprovacoes = t + a
      } catch {}
      try {
        const r = await api.get('/cidadaos')
        novosBadges.cidadaos = r.data.filter(c=>c.status==='pendente').length
      } catch {}
      if (ativo) setBadges(novosBadges)
    }
    carregarBadges()
    return () => { ativo = false }
  }, [location.pathname])

  function sair() {
    limparCachePermissoes()
    localStorage.clear()
    navigate('/login')
  }

  const grupos = [
    { titulo:'Principal', itens:[
      { label:'Dashboard', path:'/dashboard', icone:'▦' },
      pode('atendimento_presencial') && { label:'Novo processo', path:'/contribuinte-presencial', icone:'+' },
      (pode('ver_processos_setor')||pode('ver_todos_processos')) && { label:'Processos', path:'/processos', icone:'≡' },
      pode('aprovacoes') && { label:'Aprovações', path:'/aprovacoes', icone:'✅', badge: badges.aprovacoes > 0 ? badges.aprovacoes : null },
    ].filter(Boolean)},
    { titulo:'Pessoas', itens:[
      pode('ver_usuarios') && { label:'Usuários', path:'/usuarios', icone:'👤' },
      pode('ver_usuarios') && { label:'Perfis de acesso', path:'/perfis', icone:'🔑' },
      pode('ver_cidadaos') && { label:'Cidadãos', path:'/cidadaos', icone:'👥', badge: badges.cidadaos > 0 ? badges.cidadaos : null },
    ].filter(Boolean)},
    { titulo:'Configurações', itens:[
      pode('secretarias') && { label:'Secretarias', path:'/secretarias', icone:'🏛' },
      pode('tipos_processo') && { label:'Tipos de processo', path:'/tipos', icone:'🏷' },
      pode('modelos_texto') && { label:'Modelos de texto', path:'/modelos', icone:'📝' },
      pode('auditoria') && { label:'Auditoria', path:'/auditoria', icone:'🔍' },
      pode('configuracoes') && { label:'Configurações', path:'/configuracoes', icone:'⚙️' },
    ].filter(Boolean)},
    { titulo:'Portais', itens:[
      { label:'Portal do cidadão ↗', path:null, icone:'🌐', onClick:() => window.open('/portal','_blank') },
    ]},
  ].filter(g => g.itens.length > 0)

  return (
    <div style={{ display:'flex', minHeight:'100vh', fontFamily:'system-ui,sans-serif', background:'#f9fafb' }}>
      <aside style={{ width:215, background:'white', borderRight:'1px solid #e5e7eb', display:'flex', flexDirection:'column', flexShrink:0 }}>
        <div style={{ padding:'14px 16px', borderBottom:'1px solid #e5e7eb' }}>
          {usuario.logo_url && <img src={usuario.logo_url} alt="Logo" style={{ height:32, objectFit:'contain', marginBottom:6, display:'block' }} onError={e=>e.target.style.display='none'} />}
          <div style={{ fontSize:15, fontWeight:600 }}>Proto<span style={{ color:'#185FA5' }}>Gov</span></div>
          <div style={{ fontSize:11, color:'#9ca3af', marginTop:1 }}>{usuario.prefeitura||''}</div>
        </div>
        <nav style={{ padding:8, flex:1, overflowY:'auto' }}>
          {grupos.map(grupo => (
            <div key={grupo.titulo}>
              <div style={{ fontSize:10, textTransform:'uppercase', letterSpacing:'0.6px', color:'#9ca3af', padding:'10px 8px 4px' }}>{grupo.titulo}</div>
              {grupo.itens.map(item => {
                const ativo = item.path && location.pathname === item.path
                return (
                  <div key={item.label} onClick={item.onClick || (() => item.path && navigate(item.path))} style={{
                    padding:'7px 10px', borderRadius:8, cursor:'pointer', fontSize:13, marginBottom:1,
                    background:ativo?'#E6F1FB':'transparent',
                    color:ativo?'#185FA5':'#6b7280', fontWeight:ativo?500:400,
                    display:'flex', alignItems:'center', gap:8
                  }}>
                    <span style={{ fontSize:14 }}>{item.icone}</span>
                    <span style={{ flex:1 }}>{item.label}</span>
                    {item.badge && (
                      <span style={{ background:'#E24B4A', color:'white', fontSize:10, fontWeight:500, padding:'1px 6px', borderRadius:99 }}>
                        {item.badge}
                      </span>
                    )}
                  </div>
                )
              })}
            </div>
          ))}
        </nav>
        <div style={{ padding:12, borderTop:'1px solid #e5e7eb' }}>
          {senhaProvisoria && (
            <div onClick={() => navigate('/meu-perfil')} style={{ background:'#fef9c3', borderRadius:6, padding:'6px 8px', fontSize:11, color:'#854d0e', marginBottom:8, cursor:'pointer' }}>
              🔑 Senha provisória — clique para alterar
            </div>
          )}
          <div style={{ fontSize:12, fontWeight:500, color:'#111' }}>{usuario.nome}</div>
          <div style={{ fontSize:11, color:'#9ca3af' }}>{usuario.perfil}</div>
          <div style={{ display:'flex', gap:10, marginTop:6 }}>
            <span onClick={() => navigate('/meu-perfil')} style={{ fontSize:12, color:'#185FA5', cursor:'pointer' }}>Meu perfil</span>
            <span style={{ color:'#e5e7eb' }}>|</span>
            <span onClick={sair} style={{ fontSize:12, color:'#dc2626', cursor:'pointer' }}>Sair</span>
          </div>
        </div>
      </aside>
      <main style={{ flex:1, padding:24, overflowY:'auto' }}>{children}</main>
    </div>
  )
}
